import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82b674f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "remark" }
const _hoisted_2 = ["value"]

import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  height: {
    type: Number,
    required: true,
  },
},
  emits: ["update:height"],
  setup(__props, { emit }: { emit: ({
  (event: 'update:height', payload: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const slidesStore = useSlidesStore()
const { currentSlide } = storeToRefs(slidesStore)

const remark = computed(() => currentSlide.value?.remark || '')

const handleInput = (e: Event) => {
  const value = (e.target as HTMLTextAreaElement).value
  slidesStore.updateSlide({ remark: value })
}

const resize = (e: MouseEvent) => {
  let isMouseDown = true
  const startPageY = e.pageY
  const originHeight = props.height

  document.onmousemove = e => {
    if (!isMouseDown) return

    const currentPageY = e.pageY

    const moveY = currentPageY - startPageY
    let newHeight = -moveY + originHeight

    if (newHeight < 40) newHeight = 40
    if (newHeight > 120) newHeight = 120

    emit('update:height', newHeight)
  }

  document.onmouseup = () => {
    isMouseDown = false
    document.onmousemove = null
    document.onmouseup = null
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "resize-handler",
      onMousedown: _cache[0] || (_cache[0] = $event => resize($event))
    }, null, 32),
    _createElementVNode("textarea", {
      value: _unref(remark),
      placeholder: "点击输入演讲者备注",
      onInput: _cache[1] || (_cache[1] = $event => handleInput($event))
    }, null, 40, _hoisted_2)
  ]))
}
}

})